import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import M3Button from "./M3Button";
import styles from "./m3.module.css";

/**
 * Contextual bar shown while table rows are selected. Renders nothing when count is 0.
 *
 * @param {number} count - number of selected rows
 * @param {function} onClear - clears the selection
 * @param {Array} actions - { key, label, icon, onClick, variant?, disabled?, disabledReason?, tooltip?, loading?, hidden?, align?: "end" }
 * @param {[string, string]} noun - singular and plural noun, e.g. ["product", "products"]
 */
const SelectionActionBar = ({ count, onClear, actions = [], noun = ["item", "items"], clearLabel }) => {
  const { t } = useTranslation();
  if (!count) return null;
  const visible = actions.filter((a) => a && !a.hidden);
  const lead = visible.filter((a) => a.align !== "end");
  const trail = visible.filter((a) => a.align === "end");
  const closeLabel = clearLabel || t("Clear selection");

  const renderAction = (a) => (
    <M3Button
      key={a.key || a.label}
      variant={a.variant || "outlined"}
      size="sm"
      icon={a.icon}
      onClick={a.onClick}
      disabled={a.disabled}
      disabledReason={a.disabledReason}
      tooltip={a.tooltip}
      loading={a.loading}
    >
      {a.label}
    </M3Button>
  );

  return (
    <div className={styles.selBar} role="region" aria-label={t("Selection actions")}>
      <button type="button" className={styles.selClose} onClick={onClear} aria-label={closeLabel} title={closeLabel}>
        <CloseIcon fontSize="small" />
      </button>
      <span className={styles.selCount}>
        {count} {t(count === 1 ? noun[0] : noun[1])} {t("selected")}
      </span>
      <div className={styles.selActions}>
        {lead.map(renderAction)}
        {trail.length > 0 && <span className={styles.selSpacer} />}
        {trail.map(renderAction)}
      </div>
    </div>
  );
};

export default SelectionActionBar;
